// extracted by mini-css-extract-plugin
export default {"footer":"TableOrderPage_footer__nRLml","list":"TableOrderPage_list__V-5PG","container":"TableOrderPage_container__KiBIB"};